import script from "./NbsWarningLeaving.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsWarningLeaving.vue?vue&type=script&setup=true&lang=js"

import "./NbsWarningLeaving.vue?vue&type=style&index=0&id=27b5c5ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b5c5ba"]])

export default __exports__